import React, { useState } from 'react';
import A11yFontIcon from 'components/A11yFontIcon';
import ProfileIcon from 'components/ProfileIcon';
import '../GamePlayerList/GamePlayerList.css';

const PER_PAGE_COUNT = 5;

const ActiveParticipantDisplay = ({ participantData }) => {
  const [offset, setOffset] = useState(0);

  const canScrollPrev = () => offset > 0;
  const canScrollNext = () => !!participantData[offset + PER_PAGE_COUNT];

  const scrollPrev = () => {
    canScrollPrev() && setOffset(Math.max(0, offset - PER_PAGE_COUNT));
  };

  const scrollNext = () => {
    canScrollNext() && setOffset(offset + PER_PAGE_COUNT);
  };

  const addPage = (result, pageClass, data, offset, dir) => {
    let start = offset + dir;
    let end = Math.min(start + PER_PAGE_COUNT, data.length);
    start = Math.max(start, 0);
    const align = dir < 0 ? PER_PAGE_COUNT - (end - start) : 0;

    for (let index = start; index < end; ++index) {
      const user = data[index].user;
      const posClass = 'player ' + pageClass + (index - start + align);
      result.push(
        <div
          key={user.userId + index}
          className={posClass}
          title={user.displayName}
        >
          <ProfileIcon
            withBorder
            avatarData={user && user.avatarData}
            size={30}
          />
        </div>
      );
    }
  };

  const result = [];
  canScrollPrev() &&
    addPage(result, 'prev', participantData, offset, -PER_PAGE_COUNT);
  addPage(result, 'curr', participantData, offset, 0);
  canScrollNext() &&
    addPage(result, 'next', participantData, offset, +PER_PAGE_COUNT);

  return (
    <div className="game-player-list">
      <div className="player-count">
        <div className="player-count-value">{participantData.length}</div>
        <div className="player-count-label">Playing</div>
      </div>
      <div className="player-list notranslate">
        <A11yFontIcon
          icon="chevron-left"
          alt="Previous"
          className={
            !canScrollPrev() ? 'fa-disabled scroll-button' : 'scroll-button'
          }
          onClick={scrollPrev}
          type={canScrollPrev() ? 'button' : ''}
        />

        <div className="pages">{result}</div>

        <A11yFontIcon
          icon="chevron-right"
          alt="Next"
          className={
            !canScrollNext() ? 'fa-disabled scroll-button' : 'scroll-button'
          }
          onClick={scrollNext}
          type={canScrollNext() ? 'button' : ''}
        />
      </div>
    </div>
  );
};

export default ActiveParticipantDisplay;
